import { saveMapLatLngZoom } from './mapLatLngZoomSlice';
export default saveMapLatLngZoom;
